/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import Config from "data/config";
import { EmptyContentMessage } from "cms/components/layout/empty/empty-content-message";

const ScaledHeightImage = (props) => {
    
    const enableImageDebug = Config.Debug.enableDiagnostics;
    const image = props?.image;
    const settings = props?.settings;
    const width = image?.width;
    const height = image?.height;
    const url = image?.url;
    const alt = image?.alt;
    const options = settings?.options;
    const dimension = options?.dimension ?? "100%";
    const forceSixteenNine = options?.forceSixteenNine ?? false;
    const contain = options?.contain ?? false;
    const hasWidth = !!width;
    const hasHeight = !!height;
    let aspect_ratio, fit, maxWidth;
    if (forceSixteenNine) {
        aspect_ratio = "16/9";
        // fit = 'cover'
        fit = "contain";
        maxWidth = "100%";
    } else if (contain) {
        fit = "contain";
        maxWidth = "100%";
    } else if (hasWidth && hasHeight) {
        fit = "contain";
        maxWidth = "100%";
        const longerSide = height >= width ? "height" : "width";
        aspect_ratio = (longerSide === "height") ? `${height}/${width}` : `${width}/${height}`;
    }
    
    const message = "No image to display";
    const component = { type: "component.image" };
    
    return (
        <>
            {image &&
                <>
                    {enableImageDebug &&
                        <><h6>Height Priority Image (height: {dimension})</h6></>
                    }
                    <img
                        src={url}
                        alt={alt}
                        height={dimension}
                        style={{
                            aspectRatio: aspect_ratio,
                            objectFit: fit,
                            maxWidth: maxWidth,
                        }}
                    />
                </>
            }
            {!image &&
                <>
                    <EmptyContentMessage
                        hasContent={!image}
                        message={message}
                        component={component}
                    />
                </>
            }
        </>
    );
};

export { ScaledHeightImage };
